// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media only screen and (max-width:820px){#bookingStatusColumnButton[data-v-449cb979],#totalCostColumn[data-v-449cb979]{display:none}}@media only screen and (min-width:821px){#bookingStatusText[data-v-449cb979]{display:none}}", ""]);
// Exports
module.exports = exports;
